import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

const TestimonialForm = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    position: '',
    school: '',
    text: '',
    website: '' // Honeypot field - should remain empty
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await fetch(`${API_URL}/api/testimonials`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage({ type: 'success', text: data.message });
        setFormData({ name: '', position: '', school: '', text: '', website: '' });
        if (onSuccess) onSuccess();
      } else {
        setMessage({ type: 'error', text: data.error || 'Failed to submit testimonial' });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Failed to connect to server. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-2xl p-8 shadow-lg">
      <h3 className="text-2xl font-bold text-gray-900 mb-4">Share Your Experience</h3>
      <p className="text-gray-600 mb-6">
        Tell us about your training journey at The Lab. Your testimonial will be reviewed before being published.
      </p>

      {message.text && (
        <div className={`mb-6 p-4 rounded-lg ${
          message.type === 'success' 
            ? 'bg-green-100 text-green-800 border border-green-200' 
            : 'bg-red-100 text-red-800 border border-red-200'
        }`}>
          {message.text}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Honeypot field - hidden from users, catches bots */}
        <input
          type="text"
          name="website"
          value={formData.website}
          onChange={handleChange}
          tabIndex="-1"
          autoComplete="off"
          style={{
            position: 'absolute',
            left: '-9999px',
            width: '1px',
            height: '1px',
            opacity: 0
          }}
          aria-hidden="true"
        />
        
        <div>
          <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
            Full Name *
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan focus:border-transparent"
            placeholder="John Doe"
          />
        </div>

        <div>
          <label htmlFor="position" className="block text-sm font-semibold text-gray-700 mb-2">
            Position *
          </label>
          <select
            id="position"
            name="position"
            value={formData.position}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan focus:border-transparent"
          >
            <option value="">Select Position</option>
            <option value="Quarterback">Quarterback</option>
            <option value="Running Back">Running Back</option>
            <option value="Wide Receiver">Wide Receiver</option>
          </select>
        </div>

        <div>
          <label htmlFor="school" className="block text-sm font-semibold text-gray-700 mb-2">
            School/Team *
          </label>
          <input
            type="text"
            id="school"
            name="school"
            value={formData.school}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan focus:border-transparent"
            placeholder="University Name or High School"
          />
        </div>

        <div>
          <label htmlFor="text" className="block text-sm font-semibold text-gray-700 mb-2">
            Your Testimonial *
          </label>
          <textarea
            id="text"
            name="text"
            value={formData.text}
            onChange={handleChange}
            required
            rows="5"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan focus:border-transparent resize-none"
            placeholder="Share your experience training at The Lab..."
          />
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-cyan hover:bg-cyan-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
        >
          {isSubmitting ? 'Submitting...' : 'Submit Testimonial'}
        </button>
      </form>
    </div>
  );
};

export default TestimonialForm;
